


















































import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import { merge, omit } from 'lodash';

import { Configuration } from '@/models/configurator/configuration';

import mixins from '@/utils/mixins';
import functions from '@/mixins/functions';

import { IConfigurationFilterParam } from '@/services/configurator/configuration';

import ErrorAlert from '../common/ErrorAlert.vue';

const baseMixins = mixins(functions);

export default baseMixins.extend({
  components: { ErrorAlert },
  props: {
    value: {
      type: [Object, Array, Number, String]
    },

    search: String
  },
  data() {
    return {
      sortBy: 'updated_at',
      sortDesc: true,
      itemsPerPage: 25,

      params: {
        search: this.search as string,
        page: this.$route.query.page ? Number(this.$route.query.page) : 1
      },

      headers: [
        {
          text: 'Id',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Owner',
          align: 'center',
          value: 'owner'
        },

        {
          text: 'Created',
          align: 'center',
          sortable: false,
          value: 'created_at'
        },
        {
          text: 'Modified',
          align: 'center',
          justify: 'center',
          sortable: false,
          value: 'updated_at'
        },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false,

      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      configurations: 'configuratorConfiguration/getConfigurations',
      numConfigurations: 'configuratorConfiguration/getConfigurationCount'
    }),

    internalValue: {
      get(): any {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      }
    }
  },

  watch: {
    search(search: string) {
      this.params.search = search;
      this.debounceFetchConfigurations({
        ...this.params,
        page: 1
      }).then(() => {
        this.params.page = 1;
      });
    }
  },

  async mounted() {
    // update `this.params` from the route query object.
    // omitting `page` as it is already set in the data vue option
    merge(this.params, {
      ...omit(this.$route.query, ['page']),
      search: this.search
    });
    this.loading = true;

    this._fetchConfigurations(this.params);
  },

  methods: {
    moment,
    ...mapActions('configuratorConfiguration', ['fetchConfigurations']),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async debounceFetchConfigurations(params: IConfigurationFilterParam) {
      this.clearAllErrors();
      this.loading = true;

      return this.debounce(this._fetchConfigurations, 200)(params);
    },

    onUpdatePage(newPage: number) {
      if (newPage != this.params.page) {
        this.debounceFetchConfigurations({
          ...this.params,
          page: newPage
        }).then(() => {
          this.params.page = newPage;
        });
      }
    },

    _fetchConfigurations(params: IConfigurationFilterParam) {
      /* this will update the URL query based on param values. */
      this.$router
        .replace({
          name: 'configuration-list',
          query: params as Record<string, any>
        })
        .catch((e: Error) => e); //catch navigation duplication error

      return this.fetchConfigurations(params)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goToConfiguration(item: Configuration) {
      this.$router.push({
        name: 'configuration-detail',
        params: { configurationId: String(item.id) }
      });
    }
  }
});
